import React, { useContext, useState } from 'react';

import { PlusIcon } from '@vlabs/icons';
import { Control, AccountMenu, AccountMenuButton } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import { QueueContext } from '../queue-context/QueueContext';
import st from './AddButtonWithDropdown.module.sass';

export function AddButtonWithDropdown() {
  const [isDropDownOpen, setIsDropDownOpen] = useState(false);

  const { openGroupModal, openStreamModal } = useContext(QueueContext);

  const { t } = useTranslation();

  return (
    <div className={st.Wrapper}>
      <Control.Button
        data-testid="AddButtonWithDropdown_openDropdownButton"
        icon={<PlusIcon />}
        onClick={() => setIsDropDownOpen((prev) => !prev)}
      >
        {t('queue:queue page.create queue widget.add button.label')}
      </Control.Button>

      <AccountMenu
        className={st.Menu}
        isOpened={isDropDownOpen}
      >
        <AccountMenuButton
          data-testid="AddButtonWithDropdown_createStreamButton"
          onClick={() => {
            openStreamModal();
            setIsDropDownOpen(false);
          }}
        >
          {t('queue:queue page.create queue widget.menu items.stream')}
        </AccountMenuButton>
        <AccountMenuButton
          data-testid="AddButtonWithDropdown_createGroupButton"
          onClick={() => {
            openGroupModal();
            setIsDropDownOpen(false);
          }}
        >
          {t('queue:queue page.create queue widget.menu items.group')}
        </AccountMenuButton>
      </AccountMenu>
    </div>
  );
}
